import * as Yup from 'yup';
import checkoutFormModel from './formModel';

const {
    formFieldPrevencion: {
        cuit,
        premium,
        numeroSolicitud
    }
} = checkoutFormModel;

export default [
    Yup.object({
        [numeroSolicitud.name]: Yup
            .number('Ingrese el número de solicitud')
            .required(`${numeroSolicitud.requiredErrorMsg}`)
            .typeError("Introduzca únicamente números"),
        [premium.name]: Yup
            .number('Ingrese el valor de la prima emitida')
            .required(`${premium.requiredErrorMsg}`)
            .integer()
            .typeError("Introduzca únicamente números"),
    }),
    Yup.object({
        [cuit.name]:Yup.string()
                .required(`${cuit.requiredErrorMsg}`)
                .matches(/^(20|23|27|30|33)([0-9]{9}|-[0-9]{8}-[0-9]{1})$/, "El CUIT ingresado no es válido"),
    }),
];